/* eslint-disable*/

import _ from 'lodash';
import axios from 'axios';
import URLS from '../config/urls';
import Auth from './AuthService';

const DEALS_FETCH_TIME = 'dealsFetchTime';

const shouldFetchDeals = () => {
    const MINUTES = 15;
    if (localStorage.getItem(DEALS_FETCH_TIME)) {
        const lastFetchedDealsTime = parseInt(localStorage.getItem(DEALS_FETCH_TIME), 10) ?
            parseInt(localStorage.getItem(DEALS_FETCH_TIME), 10) : 0;
        const currentTime = +new Date();
        const exp = currentTime - lastFetchedDealsTime > 60 * 1000 * MINUTES;
        if (exp > 0) {
            return true;
        }
        return false;
    }
    return true;
};
export default {
    async getDeals () {
        let dealsData = [];
        if (shouldFetchDeals()) {
            let dealsData;
            await axios.get(URLS.deals, { headers: { Authorization: Auth.getToken() } })
                .then(response => {
                    dealsData = response.data;
                })
                .catch(error => {
                    console.log(error);
                });
            localStorage.setItem(DEALS_FETCH_TIME, +new Date());
            localStorage.setItem('deals', JSON.stringify(dealsData));
        }
        dealsData = JSON.parse(localStorage.getItem('deals'));
        const deals = [];
        const senderEmail = window.Office.context.mailbox.item.sender.emailAddress;
        _.forEach(dealsData, (deal) => {
            if (
                _.find(deal.contacts, { email: senderEmail }) ||
                _.find(deal.clients, { email: senderEmail })) {
                deals.push(deal);
            }
        });
        return deals;
    },
};



// WEBPACK FOOTER //
// ./src/services/DealsService.js